export const SELECT_MENU_OPTION = 'SELECT_MENU_OPTION'

export const TOGGLE_FULL_SCREEN_MODE = 'FULL_SCREEN_MODE'

export const TOGGLE_SIDEBAR_COLLAPSE = 'TOGGLE_SIDEBAR_COLLAPSE'

export const TOGGLE_SIDEBAR_BROKEN = 'TOGGLE_SIDEBAR_BROKEN'

export const TOGGLE_DRAWER_OPEN = 'TOGGLE_DRAWER_OPEN'